import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { CanditatureSourcesService } from "../../canditature-sources.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { locale as italian } from "../../../../../i18n/it";
import { AuthenticationService } from "../../../../../auth/service";
import { IDatatableConfig } from "../../../../../auth/models/datatable";
import { Router } from "@angular/router";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-sources-list",
  templateUrl: "./sources-list.component.html",
  styleUrls: ["./sources-list.component.scss"],
})
export class SourcesListComponent implements OnInit {
  public config: IDatatableConfig;

  public contentHeader: IContentHeader = null;

  public sourcesList: { id: number; name: string }[];

  public tableLimit: number = 10;

  public searchKeyword: string = "";

  public new_source: string = "";

  public currentSource: { id: number; name: string };

  public showModalError: boolean = false;

  constructor(
    public _utilService: UtilsService,
    public _sourceCandidateService: CanditatureSourcesService,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    private router: Router,
  ) {}

  async ngOnInit() {
    this.config = {
      exportable: false,
      searchable: false,
      urls: {},
      selectLimitItems: true,
      headerHeight: 30,
      rowHeight: 50,
      footerHeight: 60,
      scrollbarH: true,
      columns: [
        {
          value: "name",
          text: italian.data.FIRSTNAME,
          width: 800,
          sortable: true,
        },
      ],
    };
    this.contentHeader = {
      headerTitle: italian.data.SOURCES,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MANAGE,
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.SOURCES,
            isLink: false,
          },
        ],
      },
    };

    await this.loadSourcesList();
  }

  async loadSourcesList() {
    this.sourcesList = await this._sourceCandidateService.getList();
  }

  sourceList() {
    let items = this.sourcesList;
    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = this.sourcesList.filter((item) => item.name.toLowerCase().includes(keywords));
    }
    return items;
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  public modalOpen(modalBasic, currentSource) {
    this.new_source = "";
    this._modalService.open(modalBasic, {
      size: "sm",
      centered: true,
    });
    this.currentSource = JSON.parse(JSON.stringify(currentSource));
    this.showModalError = false;
  }

  async addSource() {
    if (!this._authenticationService.hasCapability("create_candidate_source")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (!!this.new_source) {
      this.new_source = this.new_source.trim();
    }

    if (!this.new_source || this.new_source.length < 1) {
      this.showModalError = true;
      return false;
    }

    let data: { name: string } = {
      name: this.new_source,
    };
    this._utilService.showLoading();
    await this._sourceCandidateService
      .create(data)
      .then(() => {
        this._utilService.hideLoading();
        this._modalService.dismissAll();
        this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_SOURCE" });
        this.loadSourcesList();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_UPLOAD_SOURCE" });
      });
  }

  async editSource() {
    if (!this._authenticationService.hasCapability("edit_candidate_source")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (!!this.currentSource.name) {
      this.currentSource.name = this.currentSource.name.trim();
    }

    if (!this.currentSource.name || this.currentSource.name.length < 1) {
      this.showModalError = true;
      return false;
    }
    let data: { name: string } = {
      name: this.currentSource.name,
    };
    this._utilService.showLoading();
    await this._sourceCandidateService
      .update(this.currentSource.id, data)
      .then(() => {
        this._utilService.hideLoading();
        this._modalService.dismissAll();
        this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_SOURCE" });
        this.loadSourcesList();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_EDIT_SOURCE" });
      });
  }

  async delete(currentSource) {
    if (!this._authenticationService.hasCapability("delete_candidate_source")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += currentSource.name;
    this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
      if (result.value) {
        await this._sourceCandidateService
          .delete(currentSource.id)
          .then(() => this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_SOURCE" }))
          .catch(() => this._utilService.showSWALError({ text: "ERROR_DELETE_SOURCE" }));
        await this.loadSourcesList();
      } else if (result.isDismissed) {
        await this._utilService.showSWALError({
          title: "ABORTED_TITLE",
          text: "ABORTED_TEXT",
        });
      }
    });
  }
}
